import { Vue, Component } from 'vue-property-decorator';
import { MoveDirectionEnum, FlowHierarchyTypeEnum } from '@/services/models/Enums';

@Component
export default class ConstantsHelperMixin extends Vue {
  get moveDirectionEnum() {
      return {
        up: MoveDirectionEnum.up,
        down: MoveDirectionEnum.down,
      };
  }

  get flowHierarchyTypeEnum() {
    return {
      landing: FlowHierarchyTypeEnum.landing,
      offer: FlowHierarchyTypeEnum.offer,
      path: FlowHierarchyTypeEnum.path,
      rule: FlowHierarchyTypeEnum.rule,
      utility: FlowHierarchyTypeEnum.utility,
    };
  }

  get colorEnum() {
    return {
        enabledButtonGreen: this.$colors.green,
        disabled: this.$colors.gray20,
      };
  }
}